import {
  check as checkPermission,
  PERMISSIONS,
  request as requestPermission,
  RESULTS,
} from 'react-native-permissions';
import {isNil} from 'lodash/fp';

import {
  PERMISSION_ANDROID_READ_CONTACTS,
  PERMISSION_ANDROID_WRITE_CONTACTS,
  PERMISSION_BLOCKED,
  PERMISSION_DENIED,
  PERMISSION_GRANTED,
  PERMISSION_IOS_CONTACTS,
  PERMISSION_LIMITED,
  PERMISSION_UNAVAILABLE,
  PERMISSION_UNRECOGNIZED,
} from '/enum/permission.enum';

import {log} from '../logger.util';

// Map 'react-native-permissions' constants,
// so we can avoid using variables from external library.
export const PERMISSION_MAP = {
  [PERMISSION_ANDROID_READ_CONTACTS]: PERMISSIONS.ANDROID.READ_CONTACTS,
  [PERMISSION_ANDROID_WRITE_CONTACTS]: PERMISSIONS.ANDROID.WRITE_CONTACTS,
  [PERMISSION_IOS_CONTACTS]: PERMISSIONS.IOS.CONTACTS,
};

/**
 * A string, containing a permission.
 * @typedef {(PERMISSION_ANDROID_READ_CONTACTS|PERMISSION_ANDROID_WRITE_CONTACTS|PERMISSION_IOS_CONTACTS)} PermissionKeys
 */

/**
 * A string, containing a result of permission.
 * @typedef {(PERMISSION_GRANTED|PERMISSION_DENIED|PERMISSION_BLOCKED|PERMISSION_LIMITED|PERMISSION_UNAVAILABLE|PERMISSION_UNRECOGNIZED)} PermissionResult
 */

/**
 *
 * Asks for needed permission.
 *
 * @example
 *
 * const permissionStatus = await request(PERMISSION_ANDROID_READ_CONTACTS);
 *
 * @param {PermissionKeys} permission
 * @returns {Promise<PermissionResult>}
 */
export const request = (permission: any) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (isNil(PERMISSION_MAP[permission])) {
    log('[Permission] Please specify permission.');
    return Promise.resolve(PERMISSION_UNRECOGNIZED);
  }

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return requestPermission(PERMISSION_MAP[permission]).then(result => {
    switch (result) {
      case RESULTS.UNAVAILABLE:
        return PERMISSION_UNAVAILABLE;
      case RESULTS.DENIED:
        return PERMISSION_DENIED;
      case RESULTS.LIMITED:
        return PERMISSION_LIMITED;
      case RESULTS.GRANTED:
        return PERMISSION_GRANTED;
      case RESULTS.BLOCKED:
        return PERMISSION_BLOCKED;
      default:
        return PERMISSION_UNRECOGNIZED;
    }
  });
};

/**
 *
 * Checks if the user has requested permission.
 *
 * @example
 *
 * const permissionStatus = await check(PERMISSION_ANDROID_READ_CONTACTS);
 *
 * @param {PermissionKeys} permission
 * @returns {Promise<PermissionResult>}
 */
export const check = (permission: any) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (isNil(PERMISSION_MAP[permission])) {
    log('[Permission] Please specify permission.');
    return Promise.resolve(PERMISSION_UNRECOGNIZED);
  }

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return checkPermission(PERMISSION_MAP[permission]).then(result => {
    switch (result) {
      case RESULTS.UNAVAILABLE:
        return PERMISSION_UNAVAILABLE;
      case RESULTS.DENIED:
        return PERMISSION_DENIED;
      case RESULTS.LIMITED:
        return PERMISSION_LIMITED;
      case RESULTS.GRANTED:
        return PERMISSION_GRANTED;
      case RESULTS.BLOCKED:
        return PERMISSION_BLOCKED;
      default:
        return PERMISSION_UNRECOGNIZED;
    }
  });
};
